import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NavigationService } from 'services/navigation.service';

@Component({
  selector: 'app-dashboardpopup',
  templateUrl: './dashboardpopup.component.html',
  styleUrls: ['./dashboardpopup.component.scss']
})
export class DashboardpopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DashboardpopupComponent>,
    public navigationService: NavigationService,
  ) { }

  ngOnInit() {
  }

  onCancel() {

    this.dialogRef.close();
  }
  onYes() {
   this.navigationService.goToHomeCoverage();
   this.dialogRef.close();

  }
  onNo() {
    this.navigationService.goToDashboard();
    this.dialogRef.close();
  }
}
